import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {TouchPointModel} from '../../../../../../models/touch-point.model';
import {PromotionCampaignService} from '../../../../../../services/promotion/promotion-campaign.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {PromotionTouchPointService} from '../../../../../../services/promotion/promotion-touch-point.service';

@Component({
  selector: 'kv-promo-tab-touch-point',
  template: `
    
      <app-kontable
        title="{{ 'promotion.touchPointsSelected' | translate }}"
        [columns]="['id', 'code', 'description']"
        [titles]="['#', 'promotion.code', 'promotion.description']"
        [source]="selectedTouchPoints"
        [showInfoButton]="false"
        [showRecoverButton]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [showGlobalFilter]="false"
        [showEditButton]="false"
        (onRemove)="deleteTouchPoint($event.id)"
        (onAdd)="showDialog()">
      </app-kontable>
      <label class="text-left" style="color: grey; font-style: italic;">
        {{ warningKontable}}
      </label>
      <div class="ui-g-12" style="margin-top: 40px">
        <button
          pButton
          type="submit"
          class="k-generic-btn"
          icon="fa fa-save"
          iconPos="left"
          label="{{ 'promotion.saveAll' | translate }}"
          style="float: right"
          (click)="saveAllTouchPoints()">
        </button>
      </div>
      <p-dialog
        *ngIf="showDialog"
        [modal]="true"
        [minWidth]="600"
        [draggable]="false"
        [resizable]="false"
        [(visible)]="display"
        [style]="{width: '500px', height: '500px'}">
        <p-header>
          {{chooseTouchPoints | translate}}
        </p-header>
        <form [formGroup]="form">
          <p-multiSelect
            class="multiselect-container"
            [options]="touchPoints"
            formControlName="touchPoints"
            [filter]="true"
            styleClass="multiselect-fixed-height"
            scrollHeight="350px"
            maxSelectedLabels="3">
          </p-multiSelect>
        </form>
        <p-footer>
          <button
            pButton
            type="button"
            class="k-generic-btn"
            icon="fa fa-save"
            iconPos="left"
            label="{{ 'common.reject' | translate }}"
            (click)="this.display = false">
          </button>
          <button
            pButton
            type="button"
            class="k-generic-btn"
            icon="fa fa-save"
            iconPos="left"
            label="{{ 'promotion.addAll' | translate }}"
            (click)="addAllTouchPoints(form.controls['touchPoints'].value)">
          </button>
        </p-footer>
      </p-dialog>
  `,
  styleUrls: ['./tab-touch-point.component.css']
})
export class TabTouchPointComponent implements OnInit, OnChanges {

  @Input() touchPoints;
  @Input() addEditCampaign;
  
  selectedTouchPoints: TouchPointModel[] = [];
  display = false;
  form: FormGroup;
  chooseTouchPoints;
  warningKontable;

  constructor(private svcCampaign: PromotionCampaignService,
              private fb: FormBuilder,
              private srvTranslate: TranslateService,
              private svcTouchPoint: PromotionTouchPointService) {
    this.srvTranslate.get(['promotion.chooseTouchPoints']).subscribe((res) => {
      this.chooseTouchPoints = res['promotion.chooseTouchPoints'];
    });
    this.srvTranslate.get(['promotion.warningKontable']).subscribe((res) => {
      this.warningKontable = res['promotion.warningKontable'];
    });
    this.form = this.fb.group({
      'touchPoints': null
    })
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['addEditCampaign'] &&
      changes['addEditCampaign'].currentValue &&
      changes['addEditCampaign'].currentValue !== null
    ) {
      this.svcCampaign.getTouchPoints(changes['addEditCampaign'].currentValue.id).subscribe((res) => {
        let array: any[] = [];
        for (let item of res) {
          array.push(item.ochannel_id);
        }
        this.form.controls['touchPoints'].setValue(array);
        this.addAllTouchPoints(array);
      })
    }
  }

  deleteTouchPoint(id) {
    let array1: any[] = this.form.controls['touchPoints'].value;
    let array2 = array1.filter( function (e) {
      return e !== id
    });
    this.form.controls['touchPoints'].setValue(array2);
    this.addAllTouchPoints(array2);
  }

  saveAllTouchPoints() {
    this.svcCampaign.deleteTouchPoint(this.addEditCampaign.id).subscribe( () => {
      this.svcCampaign.postTouchPoint(this.addEditCampaign.id, this.form.controls['touchPoints'].value).subscribe()
    })
  }

  showDialog() {
    this.display = true;
  }

  addAllTouchPoints(array) {
    this.selectedTouchPoints = [];
    this.svcTouchPoint.list().subscribe((res) => {
      this.selectedTouchPoints = res.data.filter(function (e) {
        return this.indexOf(e.id) >= 0;
      }, array);
    });
    this.display = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/components/tabs/touch-point/tab-touch-point-component.ts